import { Box, CircularProgress } from '@mui/material';
import { useEffect, type ReactNode } from 'react';
import { refreshSession } from '@/api/http';
import i18n, { toLanguage } from '@/i18n';
import { useAuthStore } from './authStore';

/**
 * On page load the access token is gone (memory only) -> try to restore the session from the
 * HttpOnly refresh cookie. Renders a splash screen until we know whether the user is signed in.
 */
export function AuthBootstrap({ children }: { children: ReactNode }) {
  const status = useAuthStore((s) => s.status);
  const userLocale = useAuthStore((s) => s.user?.locale);

  useEffect(() => {
    if (useAuthStore.getState().status !== 'unknown') return;
    refreshSession().catch(() => useAuthStore.getState().clear());
  }, []);

  // after login, the user's stored preference wins over browser detection (runs only when it changes)
  useEffect(() => {
    if (userLocale && toLanguage(userLocale) !== toLanguage(i18n.language)) void i18n.changeLanguage(toLanguage(userLocale));
  }, [userLocale]);

  if (status === 'unknown') {
    return (
      <Box sx={{ display: 'grid', placeItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  return <>{children}</>;
}
